import React, { useState, MouseEvent } from 'react'
import Typed, { Segment } from '../Typed'
import QuestionState from '../../types/QuestionState'
import ViewProps from '../../types/ViewProps'
import Answer from '../../types/Answer'

const SelectModal = ({ choices, onChoice }: { choices: Array<Answer>, onChoice: (answer: Answer) => void }) => {
    const [hover, setHover] = useState<{
        x: number,
        y: number,
        width: number,
        height: number,
        done: boolean,
    }>({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        done: false,
    })

    return (
        <div className={"modal modal-select" + (hover.done ? ' modal-finish' : '')}>
            <div className={"choices" + (hover.done ? ' finish' : '')}
                onMouseLeave={() => {
                    if (!hover.done) {
                        setHover({ ...hover, height: 0 })
                    }
                }}
            >
                {choices.map(q => (
                    <div
                        className={`choice`}
                        key={q.text}
                        onMouseEnter={(e) => {
                            if (!hover.done) {
                                const target = e.target as HTMLElement
                                setHover({
                                    x: target.offsetLeft,
                                    y: target.offsetTop,
                                    width: target.offsetWidth,
                                    height: target.offsetHeight,
                                    done: false,
                                })
                            }
                        }}
                        onClick={event => {
                            (event.target as HTMLElement).classList.add('selected')
                            setHover({ ...hover, done: true })
                            setTimeout(() => {
                                onChoice(q)
                            }, 800)
                        }}
                    >{q.text}</div>
                ))}
            </div>
        </div>
    )
}

export default ({ data, path, handleClick, appState, setAppState }: ViewProps) => {
    const q = data!.find(q => q.id === path)

    const [ questionState, setQuestionState ] = useState<QuestionState>({
        showModal: false,
        complete: false
    })

    const handleChoice = (answer: Answer) => {
        setQuestionState({ showModal: false, complete: true })
        setAppState({ ...appState, [path!]: answer.text, next: answer.target })
    }

    const handleModal = (event: MouseEvent<HTMLDivElement>) => {
        setQuestionState({ showModal: true })
    }

    const handleClose = () => {
        setQuestionState({ showModal: false })
    }

    const showNext = appState[path!] !== '' && !questionState.showModal ? ' show' : ''
    const question = questionState.complete ? q!.question : <Typed>{q!.question}</Typed>

    return (
        <div className={"modal-wrap default"}>
            <div className="question" onClick={handleModal}>
                {!questionState.showModal && (
                    <div>
                        <h1>{question}</h1>
                        <div className={`answer ${questionState.complete ? '' : 'animate'}`} style={{ animationDelay: `${q?.answerDelay}ms`}}>
                            {(appState[path!] as string).length === 0 ? '' : appState[path!]}
                        </div>
                    </div>
                )}
                {questionState.showModal && (<SelectModal choices={q!.answers} onChoice={handleChoice} />)}
            </div>
            <div onClick={handleClick} className={`nav-link nav-link--landing${showNext}`}>Next</div>
        </div>
    )
}
